export default "__VITE_ASSET__Bp8kptTF__"